import React, { SVGProps } from 'react';

export default function SvgComponent(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      className={`icon-svg ${props.className ?? ''}`}
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 50 45"
      fill="none"
    >
      <path
        fill="#0085FF"
        d="M10.838 2.973C16.57 7.29 22.737 16.045 25 20.743V33.15c0-.264-.102.035-.32.678-1.182 3.48-5.796 17.067-16.346 6.206-5.556-5.719-2.984-11.438 7.129-13.164-5.786.987-12.29-.645-14.074-7.043C.875 17.987 0 6.649 0 5.117c0-7.67 6.702-5.26 10.838-2.144Zm28.324 0C33.43 7.29 27.263 16.045 25 20.743V33.15c0-.264.102.035.32.678 1.182 3.48 5.796 17.067 16.346 6.206 5.556-5.719 2.984-11.438-7.128-13.164 5.785.987 12.289-.645 14.073-7.043C49.125 17.987 50 6.649 50 5.117c0-7.67-6.702-5.26-10.838-2.144Z"
      />
    </svg>
  );
}
